import React from "react";
import "leaflet/dist/leaflet.css";
import PiChart from "./PiChart";
import { Link } from "react-router-dom";

export default function ThailandMarket() {
    const handleLogout = (event) => {
        event.preventDefault();
        sessionStorage.clear('token')
        window.location = '/login'
    }

    return (
        <div>
            <div className='navbar'>
                <a href="/home">
                    <img className="cpf-logo" src="/assets/cpf-logo.jpg" />
                </a>
                <button className="logout-btn" onClick={handleLogout}>
                    Log out
                </button>
            </div>
            <div className="thailand-market-container">
                <div className="thailand-market-grid">
                    <Link className="global-market-menuitem" to="/thailand-market/quantity-animal">ปริมาณตัวสัตว์</Link>
                    <Link className="global-market-menuitem" to="/thailand-market/demand-animal">ความต้องการอาหารสัตว์</Link>
                    <Link className="global-market-menuitem" to="/thailand-market/share-market">ส่วนแบ่งการตลาดอาหารสัตว์</Link>
                    <Link className="global-market-menuitem" to="/thailand-market/sale-animal">ยอดขายอาหารสัตว์ CPF</Link>
                </div>
                <div className="dashboard-grid">
                    <iframe title="Sales Dashboard V3 (Bulid by Marketingteam)" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=cb12de6d-57f2-417c-a4a8-17b092c4f96e&autoAuth=true&ctid=8c308e15-1480-4168-aed7-b0f7a1352095" frameborder="0" allowFullScreen="true"></iframe>
                    <div className="map-insight">
                        <div className="global-market-insight">
                            <img className="cp-group-logo" src="/assets/cp-group-logo.png" />
                            <div className="global-market-insight-title">
                                <div>No.1</div>
                                <div>ปริมาณการผลิต 6.4 M Ton/yr.</div>
                                <div>ส่วนแบ่งการตลาด 40%</div>
                                <div>มูลค่าอาหารสัตว์ซีพีเอฟ 90,000 MB/yr.</div>
                            </div>
                        </div>
                        <div className="market-share">
                            Production Breakdown
                        </div>
                        <PiChart />
                    </div>
                </div>
            </div>
        </div>
    );
}

